{
  "name": "@dialectlabs/react-sdk",
  "version": "2.1.1",
  "type": "module",
  "private": false,
  "sideEffects": false,
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup-node",
    "dev": "tsup-node --watch"
  },
  "devDependencies": {
    "@types/react": "^18.2.73",
    "tsup": "^8.0.2"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/dialectlabs/react"
  },
  "dependencies": {
    "@dialectlabs/sdk": "^1.9.4",
    "swr": "^2.2.5"
  },
  "peerDependencies": {
    "react": ">=18"
  }
}
